import React from "react";
import AddClassPopup from "./AddClassPopup";
import Button from '../../../../../components/Atoms/Button.jsx';
import useDetectionStore from '../store/useDetectionStore';
import useDetectionRightStore from '../store/componentStores/useDetectionRightStore';
import useClassAttention from '../hooks/useClassAttention';
import { useSwal } from '../../../../../components/Notifications/swal/SwalCom';
const DetectionRight = () => {
    const { canvas, images, classes, currentClassId, addAdditionalClasses, currentImageIndex, setCurrentImageIndex, setCurrentClassId, updateClass, updateAnnotations, updatePolygons } = useDetectionStore();
    const { isModalOpen, setIsModalOpen, classInfo, setClassInfo } = useDetectionRightStore();
    const { swalSuccess } = useSwal();
    // highlights this card for a moment when someone tries to draw with no class
    const isNudging = useClassAttention();
    const hasClasses = (classes?.length ?? 0) > 0;
    const labeledImages = images?.filter(img => (img?.annotations?.length ?? 0) > 0 || (img?.polygons?.length ?? 0) > 0);
    const handleEditClass = (classInfo) => {
        // Implement class editing logic here
        console.log(`Edit class at index: ${classInfo}`);
        setClassInfo(classInfo)
        setIsModalOpen(true);
    };
    const handleSaveClass = (newClass) => {
        // Implement class saving logic here
        if (newClass.id) {
            updateClass(newClass);
        }
        else {
            console.log('Save new class:', newClass);

            newClass.id = (classes.length > 0 ? Math.max(...classes.map(c => c.id)) + 1 : 1).toString(); // Assign new ID
            // addAdditionalClasses([newClass]);
            addAdditionalClasses([newClass]);
        }
        swalSuccess("Saved!", "Class saved successfully.");
        setIsModalOpen(false);
    }
    const handleCurrentClass = (classId) => {
        setCurrentClassId(classId);
        handleActiveObjectChangeClass(classId);
    }

    const handleOpenSavePopup = () => {
        setClassInfo(null);
        setIsModalOpen(true);
    }
    const handleActiveObjectChangeClass = (classId) => {
        if (!canvas) return;

        const selectedObjects = canvas.getActiveObjects();
        const selectedClass = classes.find(cls => cls.id === classId);

        if (!selectedClass || selectedObjects.length === 0) {
            console.log("No objects selected or class not found");
            return;
        }

        const imgData = images[currentImageIndex];
        const updatedAnnotations = [...imgData.annotations];
        const updatedPolygons = [...imgData.polygons];

        selectedObjects.forEach(obj => {
            const idx = obj.data?.annIndex;
            const idxPoly = obj.data?.polyIndex;

            if (idx !== undefined && updatedAnnotations[idx]) {
                // ✅ Update annotation classId
                updatedAnnotations[idx] = {
                    ...updatedAnnotations[idx],
                    classId: selectedClass.id,
                };

                // ✅ Update canvas object
                obj.set({
                    stroke: selectedClass.color,
                    classData: selectedClass,
                });
            }
            else if (idxPoly !== undefined && updatedPolygons[idxPoly]) {
                updatedPolygons[idxPoly] = {
                    ...updatedPolygons[idxPoly],
                    classId: selectedClass.id,
                };

                // ✅ Update canvas object
                obj.set({
                    stroke: selectedClass.color,
                    classData: selectedClass,
                });
            }

            console.log("Updated object:", obj);
            console.log("Annotation index:", idx);
        });

        updateAnnotations(updatedAnnotations);
        updatePolygons(updatedPolygons);
        canvas.renderAll();
    };

    return (
        <>
            <div className="content-top">
                <div className={`card card-classes ${isNudging ? 'lf-attention' : ''}`}>
                    <div className="card-header card-header-classes">
                        <h5 className="card-header-classes__title">Class</h5>
                        <div className="card-header-classes__actions">
                            <Button type="button"
                                className="btn btn-add-class"
                                onClick={() => handleOpenSavePopup()}
                                tooltipText="Add new class">
                                <i className="fa fa-plus" aria-hidden></i>
                                <span>Add</span>
                            </Button>
                        </div>
                    </div>

                    <div className="card-body card-body-classes">
                        {!hasClasses ? (
                            <div className="card-body-classes__empty">
                                <p className="card-body-classes__empty-text">
                                    Create a class to start labeling.
                                </p>
                                <Button type="button"
                                    className="btn btn-add-class btn-add-class--centered"
                                    onClick={() => handleOpenSavePopup()}
                                    tooltipText="Add your first class">
                                    <i className="fa fa-plus" aria-hidden></i>
                                    <span>Add Class</span>
                                </Button>
                            </div>
                        ) : classes?.map((cls) => {
                            // the store guarantees currentClassId names a real
                            // class (the first one by default), so no fallback
                            // and no setState-during-render is needed here
                            const isActive = cls.id === currentClassId;
                            return (
                                <div
                                    key={cls.id}
                                    className={`detection-class-item ${isActive ? 'detection-class-item--active' : ''}`}
                                    style={{ '--class-color': cls.color }}
                                    onClick={() => { handleCurrentClass(cls.id) }}
                                >
                                    <span className="detection-class-item__swatch" style={{ backgroundColor: cls.color }} />
                                    <span className="detection-class-item__name">{cls.name}</span>
                                    <Button
                                        type="button"
                                        className="detection-class-item__edit"
                                        onClick={(e) => { e.stopPropagation(); handleEditClass(cls); }}
                                        tooltipText="Edit Class"
                                    >
                                        <i className="fa fa-edit"></i>
                                    </Button>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
            <div className="content-bottom">
                <div className="card">
                    <div className="card-header">
                        {/* <h5 >Labeled Images <label className="text-right text-danger">{labeledImages?.length || 0}</label></h5> */}
                        <div className="card-header d-flex justify-content-between align-items-center">
                            <h5>Labeled Images</h5>
                            <div className="card-header-right"><div className="btn-group card-option">
                                <Button type="button" className="btn btn-secondary btn-sm" tooltipText={"labeld / total images"} >{labeledImages?.length || 0} / {images?.length || 0}</Button>
                                </div></div></div>
                    </div>
                    <div className="card-body card-body-labeled">
                        <ul className="detection-labeled-list">
                            {labeledImages?.length === 0 ? (
                                <li className="detection-labeled-empty">No labeled images yet</li>
                            ) : (
                                labeledImages?.map((img, i) => (
                                    <li
                                        key={i}
                                        className={`detection-labeled-item ${images.findIndex((im) => im.fileName === img.fileName) === currentImageIndex ? 'detection-labeled-item--active' : ''}`}
                                        onClick={() =>
                                            setCurrentImageIndex(
                                                images.findIndex((im) => im.fileName === img.fileName)
                                            )
                                        }
                                    >
                                        <span className="detection-labeled-item__name" title={img.fileName}>
                                            {img.fileName}
                                        </span>
                                        <span className="detection-labeled-item__meta">
                                            {img?.annotations?.length ?? 0} boxes, {img?.polygons?.length ?? 0} polygons
                                        </span>
                                    </li>
                                ))
                            )}
                        </ul>
                    </div>
                </div>
            </div>
            <AddClassPopup isModalOpen={isModalOpen} classInfo={classInfo} handleCloseModal={() => setIsModalOpen(false)} handleSaveClass={handleSaveClass} />
        </>
    );
};

export default DetectionRight;